// Las rutas que ve la persona (las de /routes), para saber desde cualquier
// pantalla si tiene un viaje hoy (pestaña "Mi viaje" de la barra inferior).
// Las publican la home al cargarlas y RouteChatNotifier, que ya las consulta
// cada 15 s: no hace falta ninguna petición más.

let routes = [];
const listeners = new Set();

export const setMyRoutes = (list) => {
  routes = Array.isArray(list) ? list : [];
  listeners.forEach((fn) => fn(routes));
};

export const subscribeMyRoutes = (fn) => {
  listeners.add(fn);
  fn(routes);
  return () => listeners.delete(fn);
};

const pad = (n) => String(n).padStart(2, "0");
const localDay = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

// El viaje de hoy en el que va la persona (conduciendo o de pasajera): el que
// está en marcha o, si no, el siguiente por hora de salida. Como en la home,
// uno sigue contando hasta 2 h después de su hora.
export const findTodayTrip = (list, userId, now = new Date()) => {
  if (!userId || !Array.isArray(list)) return null;
  const today = localDay(now);
  const mine = list.filter((r) => {
    if (r.status === "completed" || r.status === "cancelled") return false;
    const day = r.ride_date || (r.created_at || "").slice(0, 10);
    if (day !== today) return false;
    return r.driver?.id === userId || (r.passengers || []).some((p) => p.id === userId);
  });
  const inProgress = mine.find((r) => r.status === "active" || r.status === "EN_RUTA");
  if (inProgress) return inProgress;
  const upcoming = mine
    .map((r) => ({ r, at: new Date(`${today}T${r.departure_time || "00:00"}:00`).getTime() }))
    .filter(({ at }) => at + 2 * 60 * 60 * 1000 > now.getTime())
    .sort((a, b) => a.at - b.at);
  return upcoming[0]?.r || null;
};
